export default "__VITE_PUBLIC_ASSET__540cc41d__"